// @flow
import React, { Component } from 'react'
import PropTypes from 'prop-types'

import GlobalLoader from 'app/components/Loaders/GlobalLoader'

// type Props = {
//   processEmailQuery: () => void,
// }

export class Launch extends Component {
  static propTypes = {
    processEmailQuery: PropTypes.func.isRequired,
  }

  componentDidMount() {
    this.props.processEmailQuery()
  }

  render() {
    return <GlobalLoader />
  }
}
